<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="'Earn R750 per signed and validated will'"
          :heroDescription="'Simply get registered to unlock your earning potential'"
          :section="'advisersHeader'"
          :heroButtonText="''"
          :heroButtonLink="''"
        />
      </template>
      <template v-slot:advisorEnrolmentIntro>
        <AdviserEnrolmentIntro />
      </template>
      <template v-slot:adviserEnrolmentAccentuatedContent>
        <AdviserEnrolmentAccentuatedContent />
      </template>
      <template v-slot:adviserEnrolment>
        <AdviserEnrolmentContent @showErrorMessage="showErrorMessage" />
      </template>
      <template v-slot:footer>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="`Let's grow together`"
          :heroDescription="''"
          :section="'advisersFooter'"
          :heroButtonText="''"
          :heroButtonLink="''"
        />
      </template>
    </Layout>
    <ErrorSnackbar v-model="showError" :error="errorMessage" />
  </div>
</template>

<script>
import ErrorSnackbar from "@/components/common/ErrorSnackbar.vue";
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import AdviserEnrolmentContent from "./AdviserEnrolmentContent.vue";
import AdviserEnrolmentIntro from "./AdviserEnrolmentIntro.vue";
import AdviserEnrolmentAccentuatedContent from "./AdviserEnrolmentAccentuatedContent.vue";
export default {
  name: "AdviserEnrolment",
  components: {
    Layout,
    DefaultHeroBar,
    AdviserEnrolmentContent,
    AdviserEnrolmentIntro,
    AdviserEnrolmentAccentuatedContent,
    ErrorSnackbar,
  },
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "nofollow",
      },
      {
        name: "robots",
        content: "noindex",
      },
    ],
  },
  data() {
    return {
      errorMessage: null,
      showError: false,
    };
  },
  methods: {
    showErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
      this.showError = true;
    },
  },
  computed: {
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "advisorEnrolmentIntro",
          background: "countryPattern",
          fadedRow: true,
        },
        {
          name: "adviserEnrolmentAccentuatedContent",
          class: "adviser-enrolment",
        },
        { name: "adviserEnrolment" },
      ];
    },
  },
};
</script>
